// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var baseIcon = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.charcoal),
      BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.px(23)),
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.pct(50)),
      BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translateY(BsCssJs$PrezzeeRibbon.pct(-50)))
    ]);

var hamburger = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.outlineWidth(BsCssJs$PrezzeeRibbon.px(0)),
      BsCssJs$PrezzeeRibbon.display("inlineBlock"),
      BsCssJs$PrezzeeRibbon.overflow("visible"),
      BsCssJs$PrezzeeRibbon.cursor("pointer"),
      BsCssJs$PrezzeeRibbon.transition(150, undefined, "linear", "opacity,filter"),
      BsCssJs$PrezzeeRibbon.textTransform("none"),
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.black),
      BsCssJs$PrezzeeRibbon.backgroundColor("transparent"),
      BsCssJs$PrezzeeRibbon.unsafe("height", "calc(" + (2).toString() + "px * 3 + " + (5).toString() + "px * 2)")
    ]);

var hamburgerBox = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.display("inlineBlock"),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(24)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100))
    ]);

function hamburgerInner(isOpen) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.position("absolute"),
              BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
              BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(2)),
              BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(4)),
              BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.black),
              BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.pct(50)),
              BsCssJs$PrezzeeRibbon.display("block"),
              BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(-2)),
              BsCssJs$PrezzeeRibbon.transitionProperty("transform"),
              BsCssJs$PrezzeeRibbon.transitionTimingFunction(isOpen ? ({
                        NAME: "cubicBezier",
                        VAL: [
                          0.215,
                          0.61,
                          0.355,
                          1
                        ]
                      }) : ({
                        NAME: "cubicBezier",
                        VAL: [
                          0.55,
                          0.055,
                          0.675,
                          0.19
                        ]
                      })),
              BsCssJs$PrezzeeRibbon.transitionDuration(75),
              BsCssJs$PrezzeeRibbon.transitionDelay(isOpen ? 120 : 0),
              BsCssJs$PrezzeeRibbon.transform({
                    NAME: "rotate",
                    VAL: isOpen ? BsCssJs$PrezzeeRibbon.deg(45) : BsCssJs$PrezzeeRibbon.deg(0)
                  }),
              BsCssJs$PrezzeeRibbon.before([
                    BsCssJs$PrezzeeRibbon.position("absolute"),
                    BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
                    BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(2)),
                    BsCssJs$PrezzeeRibbon.transitions(isOpen ? [
                            Css_Js_Core.Transition.shorthand(75, undefined, "ease", "top"),
                            Css_Js_Core.Transition.shorthand(75, 120, "ease", "opacity")
                          ] : [
                            Css_Js_Core.Transition.shorthand(75, undefined, "ease", "opacity"),
                            Css_Js_Core.Transition.shorthand(75, 120, "ease", "top")
                          ]),
                    BsCssJs$PrezzeeRibbon.opacity(isOpen ? 0 : 1),
                    BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(4)),
                    BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.black),
                    BsCssJs$PrezzeeRibbon.contentRule({
                          NAME: "text",
                          VAL: ""
                        }),
                    BsCssJs$PrezzeeRibbon.top(isOpen ? BsCssJs$PrezzeeRibbon.zero : BsCssJs$PrezzeeRibbon.px(-6))
                  ]),
              BsCssJs$PrezzeeRibbon.after([
                    BsCssJs$PrezzeeRibbon.position("absolute"),
                    BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
                    BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(2)),
                    BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(4)),
                    BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.black),
                    BsCssJs$PrezzeeRibbon.contentRule({
                          NAME: "text",
                          VAL: ""
                        }),
                    BsCssJs$PrezzeeRibbon.bottom(isOpen ? BsCssJs$PrezzeeRibbon.zero : BsCssJs$PrezzeeRibbon.px(-6)),
                    BsCssJs$PrezzeeRibbon.transform({
                          NAME: "rotate",
                          VAL: isOpen ? BsCssJs$PrezzeeRibbon.deg(-90) : BsCssJs$PrezzeeRibbon.deg(0)
                        }),
                    BsCssJs$PrezzeeRibbon.transitions(isOpen ? [
                            Css_Js_Core.Transition.shorthand(75, undefined, "ease", "bottom"),
                            Css_Js_Core.Transition.shorthand(75, 120, {
                                  NAME: "cubicBezier",
                                  VAL: [
                                    0.215,
                                    0.61,
                                    0.355,
                                    1
                                  ]
                                }, "transform")
                          ] : [
                            Css_Js_Core.Transition.shorthand(75, undefined, {
                                  NAME: "cubicBezier",
                                  VAL: [
                                    0.55,
                                    0.055,
                                    0.675,
                                    0.19
                                  ]
                                }, "transform"),
                            Css_Js_Core.Transition.shorthand(75, 120, "ease", "bottom")
                          ])
                  ])
            ]);
}

var Styles = {
  baseIcon: baseIcon,
  hamburgerLineHeight: 2,
  hamburgerLineGap: 5,
  hamburger: hamburger,
  hamburgerBox: hamburgerBox,
  hamburgerInner: hamburgerInner
};

function MenuToggle(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          className: hamburgerInner(props.isOpen)
                        }),
                    className: hamburgerBox
                  }),
              className: hamburger,
              onClick: props.onClick
            });
}

var make = MenuToggle;

export {
  Styles ,
  make ,
}
/* baseIcon Not a pure module */
